var exports = {
  "k": "xdbfd91f1--c52b68--container",
};

module.exports = exports;
